import React from "react"
import CampaignV2ListTableComponent from "./campaignV2ListTable.component"

export default function CampaignV2ListTableContainer({
  rows,
  isFetching,
  isError,
  page,
  tableFilter,
  rowsPerPage,
  totalFiltered,
  handleChangePage,
  handleChangeRowsPerPage,
  handleReload,
  paginationOptions,
  changeOrder,
  lang,
  language,
  handleViewDetail
}) {
  return (
    <CampaignV2ListTableComponent
      rows={rows}
      isFetching={isFetching}
      isError={isError}
      language={language}
      handleReload={handleReload}
      page={page}
      rowsPerPage={rowsPerPage}
      totalFiltered={totalFiltered}
      paginationOptions={paginationOptions}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      tableFilter={tableFilter}
      changeOrder={changeOrder}
      lang={lang}
      handleViewDetail={handleViewDetail}
    />
  )
}
